import { get, buildUrl } from './queryUtils';

/**
 * Create a fetcher for a given path and query
 * @param path - The path to fetch data from
 * @param query - The query parameters
 * @returns The fetcher function
 */
export const createFetcher = <T>(
  path: string,
  query?: Record<string, string | string[] | number | undefined>
) => {
  const url = buildUrl(path, query);
  return (token: string) => get<T>(url, token);
};